<template>
    <div>
        <div class="form-group">
            <label for="aspectLabel">{{$t('text.aspectEntry.name')}}</label>
            <input type="text" class="form-control mw-100" id="aspectLabel"
                   aria-describedby="propertyLabel"
                   name="propertyLabel"
                   v-model="property.name"
                   :disabled="editMode"
            >
        </div>

        <div class="form-group">
            <label for="aspectDisplayLabel">{{$t('text.aspectEntry.displayLabel')}}</label>
            <input type="text" class="form-control mw-100" id="aspectDisplayLabel"
                   aria-describedby="propertyLabel"
                   name="propertyLabel"
                   v-model="property.title"
            >
        </div>

        <div class="form-group">
            <label for="aspectDescription">{{$t('text.aspectEntry.description')}}</label>
            <textarea class="form-control" id="aspectDescription" aria-describedby="aspectDescription"
                      name="aspectDescription"
                      v-model="property.description"
            ></textarea>
        </div>
    </div>

</template>

<script>
    export default {
        name: "AspectEntry",
        props: {
            prefix: String,
            editMode: Boolean,
            aspectToEdit: Object,
        },
        data() {
            return {
                property: {
                    name: null,
                    title: null,
                    description: null,
                    prefixedName: null,
                }
            }
        },


        mounted() {
            if(!this.editMode) {
                this.$root.$on("createNewAspect", () => {
                    console.log("createNewAspect");
                    this.property.prefixedName = this.prefix + ':' + this.property.name;
                    this.$root.$emit("setNewAspect", this.property);
                    this.property = {
                        name: null,
                        title: null,
                        description: null,
                        prefixedName: null
                    };
                });
            }
            else {
                this.property = _.cloneDeep(this.aspectToEdit);
                this.$root.$on("editAspect", (aspect) => {
                    this.property = _.cloneDeep(aspect);
                });

                this.$root.$on("setEditedAspect", () => {
                    console.log("setEditedAspect");
                    this.$root.$emit("updateAspect", this.property);
                })
            }
        },

        beforeDestroy() {
            console.log("destroying PropertyEntry");
            this.$root.$off("createNewAspect");//
        },

        methods: {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/AspectEntry.vue